module.exports = __webpack_public_path__ + "img/github-alt.91051d68.svg";